import Nd1RecruitmentShell from "../nd1/components/Nd1RecruitmentShell";

/** @deprecated Import path kept — delegates to ND1 hiring workspace shell. */
export default function RecruitmentShell(props) {
  return <Nd1RecruitmentShell {...props} />;
}
